import greenAccept from '~/assets/images/green-accept.svg'
import redCross from '~/assets/images/red-cross.svg'

export { default as correctMascotPNG } from '~/assets/images/anatomyV2/answer-correct-mascot.png'
export { default as correctMascotWEBP } from '~/assets/images/anatomyV2/answer-correct-mascot.webp'
export { default as incorrectMascotPNG } from '~/assets/images/anatomyV2/answer-incorrect-mascot.png'
export { default as incorrectMascotWEBP } from '~/assets/images/anatomyV2/answer-incorrect-mascot.webp'

export { greenAccept, redCross }

export const CORRECT_COLOR = '#33C558'
export const INCORRECT_COLOR = '#FA9415'

export type TTrueFalseAnswer = 'true' | 'false'
